import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RolePricingSchemeLinkContainerComponent } from "./role-pricing-scheme-link-container.component";
import { RolePricingSchemeLinkListingComponent } from "./role-pricing-scheme-link-listing/role-pricing-scheme-link-listing.component";
import { RolePricingSchemeLinkAddComponent } from "./role-pricing-scheme-link-add/role-pricing-scheme-link-add.component";
import { RolePricingSchemeLinkEditComponent } from "./role-pricing-scheme-link-edit/role-pricing-scheme-link-edit.component";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AgGridModule } from "ag-grid-angular";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { SharedUtilitiesModule } from '../../../../utilities/shared-utilities.module';

@NgModule({
  declarations: [
    RolePricingSchemeLinkContainerComponent,
    RolePricingSchemeLinkListingComponent,
    RolePricingSchemeLinkAddComponent,
    RolePricingSchemeLinkEditComponent,
  ],
  imports: [
    CommonModule,
    SharedUtilitiesModule,
    FormsModule,
    ReactiveFormsModule,
    AgGridModule,
    FlexLayoutModule,
    NgxMatSelectSearchModule,
  ],
})
export class RolePricingSchemeLinkModule {}
